import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { HighlightEdgeEvent } from 'components/Graph/model/GraphCommandEvents';

export type HighlightEdgeCommand = HighlightEdgeEvent;

export const highlightEdge: GraphCommandFactory<HighlightEdgeCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('highlightEdge', command);
  };
